import { PageLayoutSkeleton } from "@features/skeletons/common/PageLayoutSkeleton/PageLayoutSkeleton";
import { ReferralSkeleton } from "../ReferralSkeleton/ReferralSkeleton";

export const ReferralPageSkeleton: React.FC = () => {
  return (
    <PageLayoutSkeleton>
      <ReferralSkeleton />
    </PageLayoutSkeleton>
  );
};
